const PATHS = {
  START_VIEW: 'START_VIEW',
  EXPLANATION_VIEW: 'EXPLANATION_VIEW',
  QUESTION_VIEW: 'QUESTION_VIEW',
  RESULT_VIEW: 'RESULT_VIEW'
}

const QUESTION_STATES = {
  CURRENT: 'CURRENT',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  NOT_ANSWERED: 'NOT_ANSWERED'
}

const TIERS = {
  TIER_ONE: 'TIER_ONE',
  TIER_TWO: 'TIER_TWO',
  TIER_THREE: 'TIER_THREE',
  TIER_FOUR: 'TIER_FOUR',
  TIER_FIVE: 'TIER_FIVE',
  TIER_SIX: 'TIER_SIX'
}

export { PATHS, QUESTION_STATES, TIERS }



// WEBPACK FOOTER //
// ./src/v1/constants/index.js